<template>
  <form class="care-form" @submit.prevent="!isLoading && $emit('submit')">
    <FieldSet label="日時" v-if="!isNew">
      <DateInput v-model="caredAt" hasTime />
    </FieldSet>

    <FieldSet
      :key="field.key"
      :label="field.label"
      v-for="field in fields"
    >
      <UiTimer
        :value="care.careData[field.key]"
        @input="v => setCareDataField({[field.key]: v})"
        v-if="field.type === 'timer'"
      />
      <RadioButtonList
        :items="field.items"
        :value="care.careData[field.key]"
        @input="v => setCareDataField({[field.key]: v})"
        v-else-if="field.type === 'radioList'"
      />
      <CheckButtonList
        :items="field.items"
        :value="care.careData[field.key]"
        @input="v => setCareDataField({[field.key]: v})"
        v-else-if="field.type === 'checkList'"
      />
      <MealMenuPicker
        :value="care.careData[field.key]"
        @input="v => setCareDataField({[field.key]: v})"
        v-else-if="field.type === 'mealMenu'" />
      <MedicinePicker
        :value="care.careData[field.key]"
        @input="v => setCareDataField({[field.key]: v})"
        v-else-if="field.type === 'medicine'" />
      <TextInput
        :value="care.careData[field.key]"
        :unit="field.unit"
        @input="v => setCareDataField({[field.key]: v})"
        :isNumber="field.type === 'number'"
        :multiline="field.type === 'textarea'"
        v-else
      />
    </FieldSet>

    <div class="submit-wrap">
      <UiButton :isLoading="isLoading">{{submitLabel}}</UiButton>
    </div>
    <div class="delete-wrap" v-if="!isNew">
      <button type="button" class="sub-action-button" @click="$emit('remove')" :disabled="isLoading">
        <i class="fas fa-trash"></i>項目の削除
      </button>
    </div>
    <div class="copy-wrap" v-if="isNew && !care.isPending && care.careType.hasCopy">
      <button type="button" class="sub-action-button" @click="$emit('copy')" :disabled="isLoading">
        <i class="fas fa-copy"></i>前回と同じ内容を入力
      </button>
    </div>
  </form>
</template>

<script>
import CheckButtonList from '@/components/molecules/CheckButtonList'
import DateInput from '@/components/atoms/DateInput'
import FieldSet from '@/components/molecules/FieldSet'
import RadioButtonList from '@/components/molecules/RadioButtonList'
import MealMenuPicker from '@/components/molecules/MealMenuPicker'
import MedicinePicker from '@/components/molecules/MedicinePicker'
import TextInput from '@/components/atoms/TextInput'
import UiButton from '@/components/atoms/UiButton'
import UiTimer from '@/components/molecules/UiTimer'

export default {
  name: 'CareForm',
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isNew: {
      type: Boolean,
      defaut: true,
    },
    submitLabel: {
      type: String,
      default: '保存',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isPending: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    CheckButtonList,
    DateInput,
    FieldSet,
    RadioButtonList,
    MealMenuPicker,
    MedicinePicker,
    TextInput,
    UiButton,
    UiTimer,
  },
  computed: {
    care: {
      get() {
        return this.value
      },
      set(care) {
        this.$emit('input', care)
      },
    },
    caredAt: {
      get() {
        return this.care.caredAt
      },
      set(caredAt) {
        this.$emit('input', { ...this.care, caredAt })
      },
    },
    fields() {
      if (this.isNew) {
        return this.care.careType.fields.filter(field => {
          if (this.isPending) {
            return field.onEndForm
          } else {
            return field.onStartForm
          }
        })
      }
      return this.care.careType.fields
    },
  },
  methods: {
    setCareDataField(partial) {
      const careData = {
        ...this.care.careData,
        ...partial,
      }
      this.care = { ...this.care, careData }
    },
  },
}
</script>

<style scoped lang="scss">
.care-form {
  display: block;
}

.submit-wrap {
  padding: 20px 35px 0;
}

.sub-action-button {
  font-size: 10px;
  padding: 15px 35px 0;
  color: $natural;

  i {
    margin-right: 0.25em;
  }
}
</style>
